



























































































































































































































































































import { defineComponent, ref, watch, onBeforeUnmount } from '@vue/composition-api';

import AtoneAlert from '@berlin-front/common/components/atone-components/AtoneAlert';
import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppCheckbox from '@berlin-front/common/components/elements/AppCheckbox';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppFormGroup from '@berlin-front/common/components/elements/AppFormGroup';
import AppInput from '@berlin-front/common/components/elements/AppInput';
import AppInputMail from '@berlin-front/common/components/elements/AppInputMail';
import AppPassword from '@berlin-front/common/components/elements/AppPassword';
import AppProgressBar from '@berlin-front/common/components/elements/AppProgressBar';
import AppRadio from '@berlin-front/common/components/elements/AppRadio';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppSelect from '@berlin-front/common/components/elements/AppSelect';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppDetails from '@berlin-front/common/components/elements/AppDetails';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';
import AppLink from '@berlin-front/common/components/elements/AppLink';
import { ModalHeaderContext } from '@services/ModalHeaderContext';
import FlashMessage from '@berlin-front/common/components/clusters/FlashMessage';
import { useContext } from '@berlin-front/common/composables/context';
import {
  LINE_HEIGHT,
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_WEIGHT,
} from '@berlin-front/common/components/elements/AppText/composable';
import { HEIGHT_TYPE } from '@berlin-front/common/components/elements/AppProgressBar/composable';
import { ALERT_TYPE } from '@berlin-front/common/components/atone-components/AtoneAlert/composable';
import { BUTTON_SIZE } from '@berlin-front/common/components/elements/AppButton/composable';
import { MemberRegisterContext } from './composable';

export default defineComponent({
  name: 'RegisterMemberView',
  components: {
    AtoneAlert,
    AppButton,
    AppCard,
    AppCheckbox,
    AppContainer,
    AppDetails,
    AppFormGroup,
    AppInput,
    AppInputMail,
    AppPassword,
    AppProgressBar,
    AppRadio,
    AppRow,
    AppSelect,
    AppText,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
    AppLink,
    FlashMessage,
  },

  setup() {
    // 会員登録処理
    const { useMemberRegister } = useContext(MemberRegisterContext);
    const {
      state,
      prefectureName,
      isEmailEditable,
      birthdayInputErrors,

      confirmButtonDisabled,

      // validate API
      progress,
      progressIsLoading,

      // 利用可能な電話番号 API
      usablePhoneNumberMessageSuccess,
      usablePhoneNumberMessage,

      // 表示項目
      SEX_DIVISION,
      sexDivisionRender,
      MONTH_LIST,
      monthToString,

      SERVICE_URL,

      // 未成年者チェック表示フラグ
      isParentalConsentCheckRequired,
      parentalConsentCheck,
      termsConsentCheck,
      // イベントハンドラー
      backClick,
      confirmClick,
      addressSearchClick,
      normalize,

      // エラーハンドラー
      alertMessages,
      errors,
      v$,
    } = useMemberRegister();

    // autocompleteの対象としてプルダウンを指定しづらい。そのため、誕生日のautocompleteはbirthdayYearで月も日も受け取る
    // 年に2000/01/01みたいなのが入力されたら年月日に分割してやります。
    const pattern = /^(\d+)[/-](\d+)[/-](\d+)$/;
    const birthdayYearInputEventHandler = (ev: Event) => {
      const { target } = ev;
      if (target === null || !(target instanceof HTMLInputElement)) return;
      const match = pattern.exec(target.value);
      if (match) {
        [, state.birthdayYear, state.birthdayMonth, state.birthdayDay] = match;
        target.value = state.birthdayYear;
      }
    };
    const appYearInputRef = ref<{ inputElement?: HTMLInputElement }>();
    watch([() => appYearInputRef.value?.inputElement], ([newInput], [oldInput]) => {
      newInput?.addEventListener('input', birthdayYearInputEventHandler);
      oldInput?.removeEventListener('input', birthdayYearInputEventHandler);
    });
    onBeforeUnmount(() => {
      appYearInputRef.value?.inputElement?.removeEventListener('input', birthdayYearInputEventHandler);
    });

    return {
      appYearInputRef,
      alertMessages,
      backClick,
      addressSearchClick,
      confirmButtonDisabled,
      confirmClick,
      normalize,
      errors,
      state,
      isEmailEditable,
      prefectureName,
      birthdayInputErrors,
      // 表示項目
      SERVICE_URL,
      isParentalConsentCheckRequired,
      parentalConsentCheck,
      termsConsentCheck,
      SEX_DIVISION,
      sexDivisionRender,
      MONTH_LIST,
      monthToString,
      usablePhoneNumberMessage,
      usablePhoneNumberMessageSuccess,

      progress,
      progressIsLoading,

      text: {
        height: {
          height150: LINE_HEIGHT.HEIGHT150,
        },

        size: {
          caption: TEXT_SIZE.CAPTION,
          heading6: TEXT_SIZE.HEADING6,
        },

        weight: {
          bold: TEXT_WEIGHT.WEIGHT700,
        },

        color: {
          error: TEXT_COLOR.ERROR,
        },
      },

      alert: {
        type: {
          warning: ALERT_TYPE.WARNING,
        },
      },

      button: {
        type: {
          high: BUTTON_SIZE.HIGH,
        },
      },

      // headerType: HEADER_TYPE.TITLE_ONLY,
      progressHeightSize: HEIGHT_TYPE.SMALL,

      v$,
    };
  },
});
